


export async function offload() {

    try {
        // await rellax.stop('.rellax')
        // await carroucel.stop()
        // await fade.stop('mainBanner')

        return true
    } catch (err) {

        console.log('err', err)

        return err
    }
}
